export default function money(value, decimal = 0) {
    return new Intl.NumberFormat("pl-PL", {
        style: "decimal",
        useGrouping: true,
        maximumFractionDigits: 0,
    }).format(value);
}
